import { isNullOrWhiteSpace } from "./stringFormatter";

export const whereStatementGen = (cond, item) => {
  let conditions = [];
  if (!isNullOrWhiteSpace(cond)) {
    conditions = cond;
  }

  const rawValue = isNullOrWhiteSpace(item.value) ? "" : String(item.value);
  const compareValue = rawValue.toLowerCase();

  for (let index = 0; index < conditions.length; index++) {
    const element = conditions[index];
    if (item.id === element.id) {
      const existingCompare = String(element.value ?? "").toLowerCase();
      if (compareValue === existingCompare) {
        return conditions;
      }
      if (isNullOrWhiteSpace(rawValue)) {
        conditions.splice(index, 1);
      } else {
        element.value = rawValue;
        if (item.name) element.name = item.name;
      }
      return conditions;
    }
  }

  if (!isNullOrWhiteSpace(rawValue)) {
    conditions.push({
      ...item,
      value: rawValue,
      name: item.name ?? "",
    });
  }

  return conditions;
};
